export default __webpack_public_path__ + "static/media/ANDREJ.ed2c28eb.png";